import { Text } from '@mantine/core'
import { useLayoutEffect, useRef } from 'react'

interface SidebarLabelProps {
  className: string
  label: string
}

export function SidebarLabel({ className, label }: SidebarLabelProps) {
  const labelRef = useRef<HTMLParagraphElement>(null)
  const contentRef = useRef<HTMLSpanElement>(null)

  useLayoutEffect(() => {
    let mounted = true

    const fitText = () => {
      const element = labelRef.current
      const content = contentRef.current
      if (!element || !content) return

      element.style.removeProperty('font-size')
      const style = getComputedStyle(element)
      const availableWidth = Number.parseFloat(
        style.getPropertyValue('--sidebar-label-width'),
      )
      const textWidth = content.getBoundingClientRect().width
      if (!availableWidth || textWidth <= availableWidth) return

      const fontSize = Number.parseFloat(style.fontSize)
      const fittedSize =
        Math.floor((fontSize * (availableWidth - 2) * 100) / textWidth) / 100
      element.style.fontSize = `${Math.max(1, fittedSize)}px`
    }

    fitText()
    void document.fonts.ready.then(() => {
      if (mounted) fitText()
    })

    return () => {
      mounted = false
    }
  }, [label])

  return (
    <Text ref={labelRef} ml="md" className={className}>
      <span ref={contentRef}>{label}</span>
    </Text>
  )
}
